module.exports = __webpack_public_path__ + "img/W7036-thumb.ba0e74a2.jpg";